<script setup lang="ts">
  import PosUiButton from '@/components/pos-v2/ui/PosUiButton.vue';
  import PosUiPopover from '@/components/pos-v2/ui/PosUiPopover.vue';
  import {
    IStatsExportColumn,
    exportStatsCsv,
    exportStatsXlsx,
  } from '@/domain/stats/stats-export';

  const props = defineProps<{
    /** Base filename without extension. */
    filename: string;
    sheetName: string;
    columns: IStatsExportColumn[];
    rows: Array<Record<string, unknown>>;
    disabled?: boolean;
  }>();

  function download(kind: 'xlsx' | 'csv', close: () => void) {
    const input = {
      filename: props.filename,
      sheetName: props.sheetName,
      columns: props.columns,
      rows: props.rows,
    };
    if (kind === 'xlsx') exportStatsXlsx(input);
    else exportStatsCsv(input);
    close();
  }
</script>

<template>
  <PosUiPopover placement="bottom" align="end" class="v2-stats-export-button">
    <template #trigger="{ toggle }">
      <PosUiButton
        color="neutral"
        variant="outline"
        size="md"
        icon="download"
        :disabled="disabled || !rows.length"
        @click="toggle"
      >
        <span class="export-label">{{ $t('v2Stats.export.export') }}</span>
      </PosUiButton>
    </template>
    <template #default="{ close }">
      <div class="export-menu">
        <button
          type="button"
          class="export-option"
          @click="download('xlsx', close)"
        >
          <i class="export-option-icon mdi mdi-file-excel-outline" />
          {{ $t('v2Stats.export.xlsx') }}
        </button>
        <button
          type="button"
          class="export-option"
          @click="download('csv', close)"
        >
          <i class="export-option-icon mdi mdi-file-delimited-outline" />
          {{ $t('v2Stats.export.csv') }}
        </button>
      </div>
    </template>
  </PosUiPopover>
</template>

<style scoped lang="scss">
  .export-menu {
    .export-option {
      @apply tw-flex tw-h-11 tw-w-full tw-items-center tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-2.5 tw-text-left tw-text-sm tw-text-neutral-700 tw-transition-colors hover:tw-bg-neutral-100;

      .export-option-icon {
        @apply tw-mr-2 tw-text-lg tw-text-neutral-500;
      }
    }
  }

  // Keep the icon-only button usable on compact widths (CSS, not v-if).
  @media (max-width: 480px) {
    .export-label {
      @apply tw-hidden;
    }
  }
</style>
